export enum BadRequestErrorMessageParameter {
  Goods = '{{ goods }}',
  Limit = '{{ limit }}',
}
